var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-coupon","size":"xl","title":"Pilih Kupon","hide-footer":""}},[_c('Table',{attrs:{"isModal":true,"eligibilityContext":_vm.eligibilityContext},on:{"chooseCoupon":_vm.chosenCoupon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }